import { type CvSection, type Document } from '../../../../generated-api'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useDocumentsStore } from '../view-stores/documents'
import type { IDropdownItem } from '@/interfaces/components/IDropdownComponent'
import { profileDropdown } from '@/application/helpers/profileHelper'
import { useLocalizationStore } from '../general-stores/localization'

export const useProfileCVStore = defineStore('profileCVStore', () => {
  const documentsStore = useDocumentsStore()
  const localizationStore = useLocalizationStore()

  // State
  const initialized = ref(false)
  const publicCVDocument = ref<Document | undefined>()

  const dropdownList = computed<IDropdownItem[]>(() =>
    documentsStore.publicDocumentId === publicCVDocument.value?.id
      ? [
          {
            id: 'item_download',
            icon: 'cloud-arrow-down',
            name: localizationStore.translate('general_Download'),
            action: 'download'
          },
          ...profileDropdown().filter((item) => item.id !== 'item_setpublic')
        ]
      : [
          {
            id: 'item_download',
            icon: 'cloud-arrow-down',
            name: localizationStore.translate('general_Download'),
            action: 'download'
          },
          ...profileDropdown().filter(
            (item) => item.id !== 'item_delete' && item.id !== 'item_setpublic'
          )
        ]
  )

  // Actions
  const init = async (item: CvSection | undefined) => {
    if (item == undefined) {
      return
    }

    publicCVDocument.value = item.publicCVDocument
    initialized.value = true
  }

  const setInitialized = (toggle: boolean) => {
    initialized.value = toggle
  }

  return {
    initialized,
    init,
    publicCVDocument,
    dropdownList,
    setInitialized
  }
})
